/**
 * @flow
 * @relayHash 4c1e20f932df6fd1716ec90f1c0d4b4c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SellerShippingPrice_sellerShippingPriceResponseData$ref = any;
export type SellerShippingPriceRefetchQueryVariables = {|
  sellerContactId?: ?string,
  overseas?: ?boolean,
|};
export type SellerShippingPriceRefetchQueryResponse = {|
  +calculateSellerShippingPrice: ?{|
    +$fragmentRefs: SellerShippingPrice_sellerShippingPriceResponseData$ref
  |}
|};
export type SellerShippingPriceRefetchQuery = {|
  variables: SellerShippingPriceRefetchQueryVariables,
  response: SellerShippingPriceRefetchQueryResponse,
|};
*/


/*
query SellerShippingPriceRefetchQuery(
  $sellerContactId: String
  $overseas: Boolean
) {
  calculateSellerShippingPrice {
    ...SellerShippingPrice_sellerShippingPriceResponseData_W50us
  }
}

fragment SellerShippingPrice_sellerShippingPriceResponseData_W50us on SellerShippingPriceSchemaType {
  calculateSellerShippingPrice(sellerContactId: $sellerContactId, overseas: $overseas) {
    locations {
      locationCode
      locationName
      baseShippingFees {
        locationCode
        locationName
        priceFrom
        priceTo
        shippingFee
      }
      additionalShippingFeesWeight {
        locationCode
        locationName
        referenceWeight
        shippingFee
        shippingFeePerAdditionalKilo
        shippingPlanDisplayId
      }
      additionalShippingFeesQuantity {
        locationCode
        locationName
        shippingFee
        shippingFeePerAdditionalQuantity
        shippingPlanDisplayId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sellerContactId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "overseas",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "overseas",
    "variableName": "overseas"
  },
  {
    "kind": "Variable",
    "name": "sellerContactId",
    "variableName": "sellerContactId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "locationCode",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "locationName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingFee",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingPlanDisplayId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SellerShippingPriceRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculateSellerShippingPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "SellerShippingPriceSchemaType",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SellerShippingPrice_sellerShippingPriceResponseData",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SellerShippingPriceRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculateSellerShippingPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "SellerShippingPriceSchemaType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "calculateSellerShippingPrice",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SellerShippingPriceResponseSchemaType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "locations",
                "storageKey": null,
                "args": null,
                "concreteType": "sellerShippingPriceLocationResponseSchemaType",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "baseShippingFees",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "sellerBaseShippingFeesSchemaType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "priceFrom",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "priceTo",
                        "args": null,
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "additionalShippingFeesWeight",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "sellerAdditionalShippingFeesWeightSchemaType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "referenceWeight",
                        "args": null,
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shippingFeePerAdditionalKilo",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "additionalShippingFeesQuantity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "sellerAdditionalShippingFeesQuantitySchemaType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shippingFeePerAdditionalQuantity",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SellerShippingPriceRefetchQuery",
    "id": null,
    "text": "query SellerShippingPriceRefetchQuery(\n  $sellerContactId: String\n  $overseas: Boolean\n) {\n  calculateSellerShippingPrice {\n    ...SellerShippingPrice_sellerShippingPriceResponseData_W50us\n  }\n}\n\nfragment SellerShippingPrice_sellerShippingPriceResponseData_W50us on SellerShippingPriceSchemaType {\n  calculateSellerShippingPrice(sellerContactId: $sellerContactId, overseas: $overseas) {\n    locations {\n      locationCode\n      locationName\n      baseShippingFees {\n        locationCode\n        locationName\n        priceFrom\n        priceTo\n        shippingFee\n      }\n      additionalShippingFeesWeight {\n        locationCode\n        locationName\n        referenceWeight\n        shippingFee\n        shippingFeePerAdditionalKilo\n        shippingPlanDisplayId\n      }\n      additionalShippingFeesQuantity {\n        locationCode\n        locationName\n        shippingFee\n        shippingFeePerAdditionalQuantity\n        shippingPlanDisplayId\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '031eb09cd61d54282de675e18f130464';
module.exports = node;
